<template>
  <div class="printed-folio-request-list-view">
    <div class="printed-folio-request-list-view__header">
      <h5 class="printed-folio-request-list-view__title">
        Folios Solicitados
      </h5>
      <button class="btn btn-primary" @click.prevent="handleClickNewPrintedFolioRequest">
        Solicitar Rango de Folios
      </button>
    </div>
    <ul class="nav nav-tabs">
      <li v-if="hasRole('medic')" class="nav-item">
        <a
          class="nav-link"
          :class="{active: activeType ==='medic'}"
          href="#"
          @click.prevent="handleClickTypeTab('medic')">Prescriptor Particular</a>
      </li>
      <li v-if="hasRole('medical_center')" class="nav-item">
        <a
          class="nav-link"
          :class="{active: activeType ==='medical_center'}"
          href="#"
          @click.prevent="handleClickTypeTab('medical_center')">Centro Médico</a>
      </li>
    </ul>
    <div v-loading="fetchingPrintedFolioRequests" class="printed-folio-request-list-view__content">
      <table class="table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th v-if="showOrganization">
              Organización
            </th>
            <th>Folio inicial</th>
            <th>Folio final</th>
          </tr>
        </thead>
        <template v-if="!fetchingPrintedFolioRequests">
          <tbody v-if="printedFolioRequests.length">
            <tr v-for="printedFolioRequest in printedFolioRequests" :key="`row-${printedFolioRequest.id}`">
              <td>{{ printedFolioRequest.created_at | dateTime }}</td>
              <td v-if="showOrganization">
                {{ printedFolioRequest.organization_name }}
              </td>
              <td>{{ printedFolioRequest.formatted_folio_start }}</td>
              <td>{{ printedFolioRequest.formatted_folio_end }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="table-warning text-center">
              <td :colspan="showOrganization ? 4 : 3">
                No se han encontrado solicitudes de folio
              </td>
            </tr>
          </tbody>
        </template>
      </table>
      <el-pagination
        background
        layout="prev, pager, next"
        :disabled="fetchingPrintedFolioRequests"
        :total="computedPagination.total"
        :page-size="computedPagination.pageSize"
        @current-change="handlePageChange" />
    </div>
    <el-dialog
      title="Ingresar Rango de Folios"
      custom-class="printed-folio-request-form__dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="showPrintedFolioRequestFormDialog"
      :before-close="handleClosePrintedFolioRequestFormDialog">
      <printed-folio-request-form
        v-if="activePrintedFolioRequest"
        :processing="processingPrintedFolioRequest"
        :printed-folio-request="activePrintedFolioRequest"
        :errors="activePrintedFolioRequestErrors"
        :organizations="organizations"
        :type="activeType"
        :printed-folio-requests="printedFolioRequests"
        @submit="handlePrintedFolioRequestFormSubmit" />
    </el-dialog>
  </div>
</template>
<script>
import PrintedFolioRequestForm from '@/components/printed-folio-request/PrintedFolioRequestForm';
import _get from 'lodash/get';

function formatFolio(folio) {
  return folio.slice(0, 4) + '-' + folio.slice(4);
}

export default {
  name: 'PrintedFolioRequestListView',
  components: {
    PrintedFolioRequestForm
  },
  data() {
    return {
      processingPrintedFolioRequest: false,
      activeType: 'medic',
      printedFolioRequests: [],
      activePrintedFolioRequest: null,
      activePrintedFolioRequestErrors: {},
      fetchingPrintedFolioRequests: false,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0
      }
    };
  },
  computed: {
    showPrintedFolioRequestFormDialog() {
      return this.activePrintedFolioRequest !== null;
    },
    organizations() {
      return this.$store.getters.organizations;
    },
    organizationsIds() {
      return this.$store.getters.organizations.map(org => org.cleanRut);
    },
    showOrganization() {
      return this.activeType === 'medical_center';
    },
    computedPagination() {
      return {
        total: this.pagination.total,
        page: this.pagination.offset === 0 ? 1 : (this.pagination.limit / this.pagination.offset) + 1,
        pageSize: this.pagination.limit
      };
    }
  },
  created() {
    this.activeType = this.hasRole('medic') ? 'medic' : 'medical_center';
    this.fetchFolioRequests();
  },
  methods: {
    getOrganizationName(organizationRut) {
      const organization = this.organizations.find(o => o.cleanRut === organizationRut);
      return organization ? organization.name : '-';
    },
    hasRole(role) {
      return this.$store.getters.hasRole(role);
    },
    handleClickTypeTab(type) {
      this.activeType = type;
      this.resetPagination();
      this.fetchFolioRequests();
    },
    resetPagination() {
      this.pagination.total = 0;
      this.pagination.offset = 0;
    },
    handlePageChange(page) {
      this.pagination.offset = (page - 1) * this.pagination.limit;
      this.fetchFolioRequests();
    },
    fetchFolioRequests() {
      this.fetchingPrintedFolioRequests = true;
      let requestType = this.activeType;
      this.$store.dispatch('fetchPrintedFolioRequests', {
        type: requestType,
        limit: this.pagination.limit,
        offset: this.pagination.offset,
        orgs: this.organizationsIds
      })
        .then(response => {
          if (this.activeType === requestType) {
            this.printedFolioRequests = _get(response, 'data.data', []).map(p => {
              p.organization_name = this.getOrganizationName(p.organization_rut);
              p.formatted_folio_start = formatFolio(p.folio_start);
              p.formatted_folio_end = formatFolio(p.folio_end);
              return p;
            });
            this.pagination.total = _get(response, 'data.meta.total', 0);
          }
        })
        .finally(() => {
          this.fetchingPrintedFolioRequests = false;
        });
    },
    handleClosePrintedFolioRequestFormDialog() {
      this.activePrintedFolioRequest = null;
      this.activePrintedFolioRequestErrors = {};
    },
    handleClickNewPrintedFolioRequest() {
      this.activePrintedFolioRequest = {
        range: {
          start: '',
          end: ''
        }
      };
    },
    handlePrintedFolioRequestFormSubmit(data) {
      this.processingPrintedFolioRequest = true;
      this.$store.dispatch('printedFolioRequest', {
        ...data,
        requestType: this.activeType
      })
        .then(response => {
          this.activePrintedFolioRequest = null;
          this.activePrintedFolioRequestErrors = {};
          this.fetchFolioRequests();
          this.$message({
            message: 'El rango de folios se ha generado correctamente.',
            type: 'success'
          });
        })
        .catch(errors => {
          this.activePrintedFolioRequestErrors = _get(errors, 'details', {});
        })
        .finally(() => {
          this.processingPrintedFolioRequest = false;
        });
    }
  }
};
</script>
<style lang="scss">
.printed-folio-request-list-view {
  background-color: $--color-white;
  border-radius: $--border-radius-base;
  padding: $--spacing-4;
  margin-top: $--spacing-4;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  &__title {
    color: $--color-blue;
    margin: 0 0 $--spacing-4 0;
  }

  .nav-tabs {
    border-bottom: none;
  }
}
</style>
